  <div *ngIf="customerportal">
    <ul class="dots">
      <li>
        <span (click)="unfolddd()" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="material-icons person-icon cursor-pointer">person</span>
        <mark (click)="openNotifications()" *ngIf="newNotificationList?.length > 0"  matTooltip="{{ 'notification.shownotifications' | trans }}" matTooltipPosition="left" class="blue wobble">{{newNotificationList.length}}</mark>
        <div class="dropdown-menu" id="user-dropdown" aria-labelledby="userDropdown">
          <a class="dropdown-item cursor-pointer" (click)="openNotifications()"><h3 class="nav-item-sub cursor-pointer">{{ 'notification.notifications' | trans }}</h3></a>        
          <a class="dropdown-item cursor-pointer" routerLink="/useraccount"><h3 class="nav-item-sub cursor-pointer">{{ 'notification.useraccount' | trans }}</h3></a>         
          <a class="dropdown-item" (click)="onLogoutClickedConfirmation()"><h3 class="nav-item-sub cursor-pointer">{{ 'notification.signout' | trans }}</h3></a>
          <a *ngIf="showConfirmation" class="dropdown-item" (click)="onLogoutClicked()"><h3 class="nav-item-sub confirm-button cursor-pointer">{{ 'notification.confirm' | trans }}</h3></a>
        </div>
      </li>
    </ul>  </div>

  <div *ngIf="!customerportal">
    <ul class="dots">
      <li>
        <span (click)="unfolddd()" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="material-icons person-icon cursor-pointer">person</span>
        <mark (click)="openNotifications()" *ngIf="newNotificationList?.length > 0"  matTooltip="{{ 'notification.shownotifications' | trans }}" matTooltipPosition="left" class="blue wobble">{{newNotificationList.length}}</mark>
        <div class="dropdown-menu" id="user-dropdown" aria-labelledby="userDropdown">
          <a class="dropdown-item cursor-pointer" (click)="openNotifications()"><h3 class="nav-item-sub cursor-pointer">{{ 'notification.notifications' | trans }}</h3></a>
          <a *ngIf="canEditOrg()" class="dropdown-item cursor-pointer" routerLink="/orgaccount"><h3 class="nav-item-sub cursor-pointer">{{ 'notification.orgaccount' | trans }}</h3></a>
          <a *ngIf="timeregEnabled()" class="dropdown-item cursor-pointer" routerLink="/time"><h3 class="nav-item-sub cursor-pointer">Time</h3></a>
          <a class="dropdown-item cursor-pointer" routerLink="/useraccount"><h3 class="nav-item-sub cursor-pointer">{{ 'notification.useraccount' | trans }}</h3></a>
          <a class="dropdown-item" (click)="onLogoutClickedConfirmation()"><h3 class="nav-item-sub cursor-pointer">{{ 'notification.signout' | trans }}</h3></a>
          <a *ngIf="showConfirmation" class="dropdown-item" (click)="onLogoutClicked()"><h3 class="nav-item-sub confirm-button cursor-pointer">{{ 'notification.confirm' | trans }}</h3></a>
        </div>
      </li>
    </ul>
  </div> 

  <!-- <div [@inbgOutAnimation] *ngIf="newNotificationList.length > 0 && showNotifications" class="notification-list cursor-default">
      <div class="row notification-header" style="margin-left:0px;">
        <div class="col">
          <h6 class="notification-header">{{ 'notification.notifications' | trans }}</h6>
        </div>
        <div class="col-auto">
          <button  type="button" class="close"(click)= "toggleList()" aria-label="Close">
            <span >&times;</span>
          </button>
        </div>
      </div>
    <div *ngFor="let notf of notificationList;let i= index"  class="notification-card">
      <div class="row">
      <div class="col cursor-pointer" (click)="navigate(notf.link)">
        <h6 class="notification-title">{{notf.notificationtitle}}</h6>
        <p class="notification-desc">  <quill-view-html [content]="notf.notificationdescription" theme="snow"></quill-view-html>
          </p>  
        <p class="notfication-timestamp">{{ 'notification.created' | trans }}{{notf.datecreated | date: 'yyyy-MM-dd HH:mm'}}</p>  
      </div>
      <div class="col-">
        <span (click)="markRead(notf)" matTooltip="{{ 'notification.markreadtip' | trans }}" matTooltipPosition="above" class="material-icons notification-icon-msg zoom">
          mark_chat_read
          </span>
      </div></div>
 
<!---
      <div class="row">
        <div class="col-auto">
          <h6 class="comment-title">{{notf.notificationtitle}}</h6>
        </div>
        <div class="col-auto">
          <span (click)="markUnRead(notf)" matTooltip="Mark Message Unread" matTooltipPosition="above" class="material-icons notification-icon-msg zoom">
            mark_chat_unread
            </span>
        </div>
        <div class="col-auto">
          <span (click)="markRead(notf)" matTooltip="Mark Message Read" matTooltipPosition="above" class="material-icons notification-icon-msg zoom">
            mark_chat_read
            </span>
        </div>
      </div>
      <p class="comment-content">{{notf.notificationdescription}}</p>
      <p class="comment-date">{{notf.datectreated}}</p>-->
    <!-- </div>
    <h6 (click)="toggleList(); showOldNotifications()" class="view-all">{{ 'notification.viewall' | trans }}</h6>
</div> -->
<app-notification-push *ngIf="webpush" [webpush]="webpush"></app-notification-push>


<div *ngIf="showConfirmation" [@inbgOutAnimation] class="modal-custom">
  <div class="modal-custom-box">
    <h6 class="confirm-header">{{ 'notification.areyoustaying' | trans }}</h6>
    <p class="confirm-text">{{ 'notification.pressabuttontocontinue' | trans }}</p>
  <div class="row">
    <div class="col">
      <button (click)="onLogoutClickedStay()" class="confirm-signout btn-secondary"><h6 class="btn-save-text">{{ 'notification.stay' | trans }}</h6></button>
    </div>
    <div class="col">
      <button (click)="onLogoutClicked()" class="confirm-signout btn-save"><h6 class="btn-save-text">{{ 'notification.leave' | trans }}</h6></button>
    </div>
  </div>

  </div>
</div>

<!-- Button trigger modal
<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalScrollable">
  Launch demo modal
</button>
 -->
<!-- Modal -->
<!-- <div *ngIf="showAllNotifications" class="modal-custom" >
 
  <div class="modal-dialog modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalScrollableTitle">{{ 'notification.notificationhistory' | trans }}</h5>
        <button (click)="closeAllNotification()" type="button" class="close" aria-label="Close">
          <span >&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngFor="let notf of notificationInclReadList;let i= index"  class="notification-card-list">
          <div [ngClass]="isread(notf) ? 'read' : 'un-read' " class="row row-notification">
          <div class="col" (click)="navigate(notf.link)">
            <h6 class="notification-title">{{notf.notificationtitle}}</h6>
            <p class="notification-desc">{{notf.notificationdescription}}</p>  
            <p class="notification-date">{{ 'notification.created' | trans }}{{notf.datecreated | date: 'yyyy-MM-dd HH:mm' }}</p>  
          </div>
          <div *ngIf="!isread(notf)" class="col-">
            <span (click)="markRead(notf)" matTooltip="{{ 'notification.markreadtip' | trans }}" matTooltipPosition="above" class="material-icons notification-icon-msg zoom">
              mark_chat_read
              </span>
          </div></div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="closeAllNotification()" type="button" class="btn btn-knowledge"><h6 class="button-text">{{ 'notification.close' | trans }}</h6></button>
      </div>
    </div>
  </div>
</div> -->
